/**
 * @file queueConstants.js
 * @description Constants for the Queue module within the IVR section.
 *              Includes UI label strings, table configurations, messages, and error constants.
 *
 * @module queueConstants
 *
 * @exports QUEUE_STRINGS   - UI label strings for the queue panel.
 * @exports QUEUE_KEYS      - Key mappings for queue data.
 * @exports QUEUE_TABLE_COLUMNS - Column definitions for the queue table.
 * @exports QUEUE_TABLE_COLUMN_KEYS - Column key mappings for the queue table.
 * @exports QUEUE_MESSAGES  - Message strings for queue operations.
 * @exports QUEUE_ERRORS    - Error message strings for queue data fetching.
 */
export const QUEUE_STRINGS = {
    ADD_QUEUE: "Add Queue",
    EDIT_QUEUE: "Edit Queue",
    QUEUE_NAME: "Queue Name",
    SEARCH_QUEUE: "Search Queue",
    QUEUE_POLICY: "Policy",
    QUEUE_LABEL: "Label",
    QUEUE_ID: "Queue ID",
    DELETE_QUEUE: "Delete Queue",
};

export const QUEUE_KEYS = {
    ID: "id",
    QUEUE_NAME: "queuename",
    DISTRIBUTION_POLICY_ID: "distributionPolicyId",
    LABEL_ID: "labelId",
}

export const QUEUE_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "id", isSortable: true, label: "Queue ID" },
    { id: "queuename", isSortable: true, label: "Queue Name" },
    { id: "distributionPolicyId", isSortable: true, label: "Policy" },
    { id: "labelId", isSortable: true, label: "Label" },
];

export const QUEUE_TABLE_COLUMN_KEYS = {
    ID: "id",
    ACTIONS: "actions",
    QUEUE_NAME: "queuename",
    DISTRIBUTION_POLICY_ID: "distributionPolicyId",
    LABEL_ID: "labelId",
};

export const QUEUE_MESSAGES = {
    NO_QUEUE: "No queue to display",
    QUEUE_ADDED: "Queue added successfully.",
    QUEUE_UPDATED: "Queue updated successfully.",
    QUEUE_DELETED: "Queue deleted succesfully."
};

export const QUEUE_ERRORS = {
    ADD_QUEUE_ERROR: "Error adding queue:",
    SAVE_QUEUE_ERROR: "Error saving queue:",
    UPDATE_QUEUE_ERROR: "Error updating queue:",
    FETCH_QUEUE_ERROR: "Error fetching queue:",
    DELETE_QUEUE_ERROR: "Error deleting queue",
};